import type { ReactNode } from 'react';

/**
 * Bingkai untuk layar SEBELUM masuk: masuk, pemulihan kata sandi, dan menerima undangan.
 *
 * Ketiganya sebelumnya menyalin `.shell` + bilah judul hitam — kerangka aplikasi bagian DALAM,
 * dipakai pada layar yang belum punya aplikasi untuk dibingkai. Selain menempatkan formulir di
 * pojok kiri atas layar lebar, penyalinan itu berarti setiap perbaikan pada blok merek harus
 * dikerjakan tiga kali; dua kali pertama sudah pernah luput.
 *
 * Bahasanya mengikuti layar masuk CRM (arah owner 21 Agu): satu kartu putih di tengah kanvas
 * ivory, merek di atas, tombol biru selebar kartu.
 *
 * Anaknya membawa `.card` masing-masing dan itu memang dibiarkan — `.auth-card .card` di
 * styles.css meratakannya jadi isi biasa, sehingga ketiga layar itu tidak perlu diubah untuk
 * ikut berpindah kulit.
 */
export function AuthLayout({ children }: { readonly children: ReactNode }): ReactNode {
  return (
    <div className="auth-screen">
      <div className="auth-card">
        <div className="auth-brand">
          {/*
            Lambang resmi (arah owner 21 Agu), menggantikan tanda-centang sementara yang saya
            gambar sendiri. `alt` sengaja KOSONG: namanya sudah tertulis sebagai <h1> tepat di
            bawahnya, jadi memberinya teks alternatif membuat pembaca layar menyebut merek yang
            sama dua kali. Lebar & tinggi ditulis eksplisit agar kartunya tidak melompat saat
            gambar selesai dimuat.
          */}
          <img
            className="auth-mark"
            src="/icon-192.png"
            alt=""
            width={56}
            height={56}
            decoding="async"
          />
          <h1>SalesHub Pro Workforce</h1>
          <p className="muted small">Kehadiran &amp; eksekusi pekerjaan lapangan</p>
        </div>
        {children}
      </div>
      <p className="muted small">© 2026 SalesHub Pro · PT. Damha Amanatan Medika</p>
    </div>
  );
}
